<div class="logo-container">
  <img src="/assets/logo/logo-full-green.png" alt="" />
  <label for="">{{ companyName$ | async }}</label>
  <!-- <label for="">Company's Name</label> -->
</div>
